module.exports = __webpack_public_path__ + "media/images/icons/pdf_icon-544258a41a8ac43cdf06bdd48d535ac8.svg";